/**
 * @file
 * Custom JS behaviour for search form.
 */

(function ($) {

  Drupal.behaviors.search = {
    attach: function (context, settings) {

      //
      once('initialized', '.path-search-products main .layout-before-content', context).forEach(($box) => {
        let height = $box.offsetHeight;

        let windowHeight = window.innerWidth;

        function css(element, style) {
          for (const property in style) {
            element.style[property] = style[property];
          }
        }

        if (height > windowHeight) {
          css($box, {
            'position': 'relative',
          });
        }
      });

      const mediaQuery = window.matchMedia('(min-width: 1200px)');
      // Search.
      //const $searchBtn = document.querySelector('.header-top a.search-btn');

      once('initialized', '.header-top a.search-btn', context).forEach((el) => {
        el.addEventListener('click', event => {
          if (mediaQuery.matches) {
            event.preventDefault();
            document.querySelector('#block-formespostosearch-contentspage-1').classList.toggle('opened');
          }
        });
      });

      once('initialized', '.region-search-bar form', context).forEach((el) => {
        const $productCheckbox = document.querySelector('input[value="product"]');
        const $productLines = document.querySelector('fieldset[data-drupal-selector="edit-field-product-lines"]');
        const checked = (e) => {
          if ($productCheckbox.checked) {
            $productLines.classList.toggle('opened');
          }
        };
        checked();
        $productCheckbox.addEventListener('change', event => {
          $productLines.classList.toggle('opened');
        });
      });

    },
  };

})(jQuery);
